import { render, staticRenderFns } from "./shipment_weigh_queue.vue?vue&type=template&id=7f90761d"
import script from "./shipment_weigh_queue.vue?vue&type=script&lang=js"
export * from "./shipment_weigh_queue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports